// extracted by mini-css-extract-plugin
export default {"cover":"styles_cover__uLee8","cover__img":"styles_cover__img__S2-1P","text":"styles_text__C6MTP"};